import { render } from "./ChartDivComponent.vue?vue&type=template&id=b980d7b2&ts=true"
import script from "./ChartDivComponent.vue?vue&type=script&lang=ts"
export * from "./ChartDivComponent.vue?vue&type=script&lang=ts"

import exportComponent from "/var/www/rentasdhelos.com/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__